import m from 'mithril';
import * as ProRail from "../../state/data/prorail";
import { IDX } from "../../state/data/prorail";
import { getText } from "../../state/translations";
import "./prorail.scss";
import { isZentrakResult, ZENTRAK_LOGO } from '../../state/zentrak';
export const railProContent = (name, item, child) => {
    const arr = Array.isArray(item)
        ? [
            item[IDX.type],
            item[IDX.wisselligger],
            item[IDX.hoekverhouding],
            item[IDX.profiel],
            item[IDX.boogstraal],
            item[IDX.smeerlozeConstructie],
            item[IDX.classificatie],
            item[IDX.plaatsingsdatum],
            item[IDX.tekeningnummer],
            item[IDX.afschrijvingsgroep]
        ]
        : [
            item.type,
            item.wisselligger,
            item.hoekverhouding,
            item.profiel,
            item.boogstraal,
            item.smeerlozeConstructie,
            item.classificatie,
            item.plaatsingsdatum,
            item.tekeningnummer,
            item.afschrijvingsgroep,
        ];
    const z = Array.isArray(item)
        ? isZentrakResult(item[IDX.key], item[IDX.geocode])
        : isZentrakResult(item.key, item.geocode);
    return [
        m("p", null,
            m("b", null, name),
            child),
        m("div", null,
            z && [
                m("div", null),
                m("div", null,
                    m("img", { className: "logo-zentrak", src: ZENTRAK_LOGO }))
            ],
            [
                "SWITCH_TYPE",
                "SLEEPER_TYPE",
                "ANGLE_RATIO",
                "RAIL_PROFILE",
                "RADIUS",
                "LUBRICANT_FREE_CONSTRUCTION",
                "CLASSIFICATION",
                "PLACEMENT_DATE",
                "DRAWING_NUMBER",
                "AFSCHRIJVINGSGROEP_TODO"
            ]
                .map((x, i) => [x, arr[i]])
                .filter(([, value]) => Boolean(value))
                .flatMap(([label, value]) => [
                m("div", null,
                    getText(label),
                    ":"),
                m("div", null, getText(value, undefined, value))
            ]))
    ];
};
